import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { 
    CircleCheck,
    Clock, 
    Inbox,
    MessageCircle,
} from "lucide-react";
import MessageDashBoard from "./MessageDashBoard";

const EmployeeInboxTabs = ({ messages, selectedDepartment, getStatusDisplay }) => {
    const [activeTab, setActiveTab] = useState("All");
    
    const filteredByDept =
    selectedDepartment === "All"
        ? messages
        : messages.filter(
            (m) => m.tic_department_id === selectedDepartment
        );

    const mainTickets = filteredByDept.filter(m => !m.tic_parent_id);

    const counts = {
        All: filteredByDept.length,
        Pending: mainTickets.filter(m => getStatusDisplay(m.ticket_status) === "pending").length,
        Responded: mainTickets.filter(m => getStatusDisplay(m.ticket_status) === "responded").length,
        Resolved: mainTickets.filter(m => getStatusDisplay(m.ticket_status) === "resolved").length,
    };

    const filteredMessages =
        activeTab === "All"
            ? filteredByDept
            : filteredByDept.filter(m => {
                if (m.tic_parent_id) return false; 
                return getStatusDisplay(m.ticket_status) === activeTab.toLowerCase();
            });

    const tabOptions = [
        { 
            label: `All (${counts?.All})`, 
            value: "All",
            icon: <Inbox/>,
        },
        { 
            label: `Pending (${counts?.Pending})`, 
            value: "Pending",
            icon: <Clock/>,
        },
        { 
            label: `Responded (${counts?.Responded})`, 
            value: "Responded",
            icon: <MessageCircle/>,
        },
        { 
            label: `Resolved (${counts?.Resolved})`, 
            value: "Resolved",
            icon: <CircleCheck/>,
        },
    ];


    return (
        <div className="flex flex-col gap-2 space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
                height="h-12"
            />
            <MessageDashBoard
                messages={filteredMessages}
                getStatusDisplay={getStatusDisplay}
            />
        </div>
    );
};

export default EmployeeInboxTabs;
